<template>
	<v-container
		:style="{ maxWidth: typeCheck(maximumWidth) }"
		class="d-flex flex-column flex-grow-1"
	>
		<slot />
	</v-container>
</template>

<script setup>
import { defineProps, defineOptions } from 'vue'

defineOptions({
	name: 'BaseContainer',
})

defineProps({
	maximumWidth: {
		type: [String, Number],
		default: '960px',
	},
})

const typeCheck = (value) => (typeof value === 'string' ? value : `${value}px`)

</script>
